export class AddAgencyDto {
    name!: string;    
    imageUrl: string;
}